module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['a-input-text', 'a-input-text-div__' + _vm.name]
  }, [(_vm.labelText !== '') ? _c('label', {
    class: ['a-input-text__label', _vm.name + '-label'],
    attrs: {
      "for": _vm.name
    }
  }, [_vm._v(_vm._s(_vm.labelText))]) : _vm._e(), _vm._v(" "), _c('input', {
    ref: _vm.name,
    staticClass: "a-input-text__input",
    class: {
      'a-input--danger': _vm.errorMessage !== '', 'a-input--success': _vm.successState
    },
    attrs: {
      "type": _vm.type,
      "id": _vm.name,
      "name": _vm.name,
      "autocomplete": _vm.autocomplete,
      "maxlength": _vm.maxlength,
      "minlength": _vm.minlength,
      "labelText": _vm.labelText,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "required": _vm.required,
      "aria-required": _vm.required
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "change": function($event) {
        return _vm.$emit('change', $event.target.value)
      },
      "input": function($event) {
        return _vm.$emit('input', $event.target.value)
      },
      "keyup": function($event) {
        return _vm.$emit('keyup', $event)
      },
      "keypress": function($event) {
        return _vm.$emit('keypress', $event)
      }
    }
  }), _vm._v(" "), (_vm.errorMessage !== '') ? _c('p', {
    staticClass: "a-input__error-message"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-93059066","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/checkout/components/atoms/InputText.vue
// module id = 542
// module chunks = 2